/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormEditCreateUpdateListMultiItemFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/multi-item/create-update/form-edit-create-update-list-multi-item-field-dialog.component';
/* eslint-enable */

/**
 * ListItem field implementation.
 */
export class FormEditListMultiItemFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateListMultiItemFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateListMultiItemFieldDialogComponent)
      .create(this.injector);
  }

}
